import React from 'react';

import { appConfig } from '../services';

const proxyFormOperations = (WrappedComponent) => {
    class ProxyFormOperations extends React.Component {
        constructor(props) {
            super(props);

            this.state = {
                targetURL: "",
                hasError: false
            };
        }

        normalizeURL = (url) => {
            const clearUrl = url.trim();

            const hasProtocol = /^[a-zA-Z][a-zA-Z\d+\-.]*:\/\//.test(clearUrl);

            if (!hasProtocol) {
                return `https://${clearUrl}`;
            }

            return clearUrl;
        }

        onChangeTargetURL = (e) => {
            this.setState({ hasError: false });
            this.setState({ targetURL: e.target.value });
        }

        handleSubmitURL = () => {
            const targetURL = this.normalizeURL(this.state.targetURL);

            const doFetch = () => {
                this.setState({ hasError: false });

                const url = new URL(appConfig.defines.PROXY_URL);
                const { origin, pathname } = new URL(targetURL);

                url.searchParams.set("target", origin);
                url.pathname = pathname;

                if (!url.pathname.includes(".") && !url.pathname.endsWith("/")) { // add "/" to folder
                    url.pathname = url.pathname + "/"
                }

                fetch(url.toString())
                    .then((response) => {
                        const repsonseContent = response.headers.get("Content-Type");
                        const isHTMLRepsonse = repsonseContent.indexOf("text/html") !== -1;

                        if (isHTMLRepsonse) {
                            return window.location.href = url.toString();
                        }

                        this.setState({ hasError: true });
                    })
                    .catch(() => this.setState({ hasError: true }))
            }

            try {
                new URL(targetURL); // returns error if entered target url is broken
                doFetch();
            } catch (e) {
                this.setState({ hasError: true });
            }
        }

        render() {
            return (
                <WrappedComponent
                    {...this.props}

                    targetURL={this.state.targetURL}
                    hasError={this.state.hasError}

                    onChangeTargetURL={this.onChangeTargetURL}
                    handleSubmitURL={this.handleSubmitURL}
                />
            );
        }
    }

    return ProxyFormOperations;
}

export default proxyFormOperations;